import { render } from "./GruposView.vue?vue&type=template&id=64f08758&scoped=true"
import script from "./GruposView.vue?vue&type=script&lang=js"
export * from "./GruposView.vue?vue&type=script&lang=js"

import "./GruposView.vue?vue&type=style&index=0&id=64f08758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f08758"]])

export default __exports__